module.exports = __webpack_public_path__ + "static/media/ntit.9eade542.jpg";